import z from 'zod';
import { GeocodedAddressSchema } from '~/lib/model';
import { createPerformableConfig, TenantId } from '~/tenants/common/registry';
import { coerceLiteralNumberRequired, FIRST_VERSION_TIMESTAMP } from '~/lib/zod';

export enum MlmFlyerQuantity {
  QTY_25 = '25',
  QTY_50 = '50',
  QTY_100 = '100',
  QTY_250 = '250',
}

export enum MlmFlyerShipping {
  STANDARD = 'standard',
  PICKUP = 'pickup',
  RUSH = 'rush',
}

export default createPerformableConfig(
  'flyer',
  {
    [FIRST_VERSION_TIMESTAMP]: z.object({
      version: coerceLiteralNumberRequired(FIRST_VERSION_TIMESTAMP),
      quantity: z.nativeEnum(MlmFlyerQuantity),
      shipping: z.nativeEnum(MlmFlyerShipping).optional(),
      delivery: GeocodedAddressSchema.optional(),
    }),
  },
  {
    name: 'Flyer',
    thumbnail: 'tenant/mpi/brochure/1.jpg',
    short:
      'High quality pront material, professionally designed and printed, poised to impress clients and potential buysers alike. Turn around time varies based off the size of your job. Please contact us if you have any questions before ordering.',
    tenant: TenantId.MAINE_LINE_MEDIA,
    images: [],
    group: 'Print',
  },
);
